import { Message } from '@arco-design/web-react';
import { FC } from 'react';
import { styled } from 'styled-components';

const DownloadWrap = styled.div`
  cursor: pointer;
`;

const Download: FC<{ msgBody: string; className?: string }> = (props) => {
  return (
    <DownloadWrap className={props.className}>
      <img
        onClick={() => {
          try {
            const srcObj = JSON.parse(props.msgBody);
            const url = srcObj.resource?.url;
            const key = srcObj.resource?.key;
            const link = key ? `${url}?sign=${key}` : `${url}`;
            console.log('link...', link);
            url && window.open(link);
          } catch (error) {
            Message.error($t('chat_session_status_22'));
          }
        }}
        src={require('@img/common/icon-download.svg')}
        alt=""
        className="w-64 md:w-35"
      />
    </DownloadWrap>
  );
};

export default Download;
